<template>
  <main-layout>
    <div class="container">
        <br><br><br>
      <H1 class="pageTitle isPoppins">Frequently Asked Questions</H1>
      <div class="top15 accSettingsForm aboutText">

          <div class="question">
              What are slinks?
          </div>
          <div class="answer">
              Slinks are words or short phrases that when triggered by entering them into a web browser address bar prefaced by the "slink.com/" domain, automatically redirect the browser to 
              a URL of the slink owners choosing. E.g. we have setup the slink 'music' to redirect the browser to 'https://en.wikipedia.org/wiki/music'.  You can try this by entering the following into a browser or 
              clicking on it:  <a href="https://slink.com/music" class="has-text-warning"><b>slink.com/music</b></a>
          </div>

          <div class="question">
              Why use slinks?
          </div>
          <div class="answer">
              There are many reasons why slinks are useful. Slinks are easy to remember alternatives to complicated URLs and the use of intuitive words that are related to the underlying
              URL destination you are trying to drive traffic to, will make it much easier for your audiences to reach you. If you owned the slink 'chocolate' and your company sells chocolate, 
              it would be much easier for your potential customers to find you using the slink, rather than remembering your actual company name or webpage domain. Short, intuitive domain names
              themselves are difficult or expensive to get. Slinks serve as a meta-layer to simplify driving traffic. Additionally, many social platforms prevent the clicking of URLs in posts. By
              providing them with a slink instead, your readers can easily reach the URL you would like them to visit by entering the slink prefaced by 'slink.com/' into their browser. You can also use slinks to redirect to email addresses, social media profiles, 
              digital wallets, online videoconference meeting id's and any other service that can be reached via a URL. 
          </div>

           <div class="question">
              How easily and often can I change the URL my slinks redirect to? How long does it take for the change to reflect?
          </div>
          <div class="answer">
              It is very easy to change the target URL of a slink. You can do this from the "Manage Services" option in the "My Account" menu, once you are logged in.
              You can change the targt URL of your slinks as often as you like. The change reflects immediately.
          </div>

           <div class="question">
              What are subslinks?
          </div>
          <div class="answer">
              A subslink is an extension of a slink that has its own independent redirection URL.  So subslink of the slink 'music' might be 'music:guitar'. A colon followed by another word is used to
              extend the root slink word.  So while the slink music will redirect to one URL, the subslink music:guitar can redirect to an entirely different on. Once you have obtained a slink, you have the right to control any subslinks
              derived from it. Each slink you purchase comes bundled with the option to create a number of subslinks. You will be able to upgrade to plans with higher subslink counts.
              You can manage your slink's subslinks from the "Manage Services" option in the "My Account" menu, once you are logged in.
          </div>

           <div class="question">
              How long do subscriptions last?
          </div>
          <div class="answer">
              Everything you purchase on the Slink website is on a yearly subcription basis. The subscription will renew automatically unless you cancel it.  Each product purchased 
              has it's own billing cycle.
              If billing fails on the renewal date, you will have a short grace period to provide an alternaate payment mechanism, after which your slinks will be removed from your account
              and become available for others to purchase.
          </div>

           <div class="question">
              What about brand names or words and phrases protected by trademarks?
          </div>
          <div class="answer">
              A trademark gives its owner exclusive right to the use of a protected word or phrase. If you know a word or phrase is a trademark and you do not own that trademark, do
              not attempt to purchase it as a slink. We reserve the right to remove a trademarked slink from your account, if the rightful trademark owner files a succesful claim. For more information,
              please refer to our Terms and Conditions.
          </div>

          <br> <br> <br>
      </div>
    </div>
  </main-layout>
</template>

<script>
import { I } from 'caniuse-lite/data/agents';
import MainLayout from '../layouts/Main.vue'

export default {
  components: {
    MainLayout
  },


  methods: {
   
  }
}

</script>


// WEBPACK FOOTER //
// src/pages/FAQ.vue